import { Box, Button, Center, Heading, HStack, Image, Input, Select, SimpleGrid, Tag, Text, useToast, VStack } from '@chakra-ui/react'
import { Stream } from '@cloudflare/stream-react'
import { collection, doc, getDocs, updateDoc } from 'firebase/firestore'
import React, { useEffect, useState } from 'react'
import { db } from '../../Configs/firebase'
import colors from '../../Utils/colors'
import { uploadFile } from '../../Utils/FirebaseStorage'

function EditDataContent({editData, setEditData}) {

    const [title, setTitle] = useState("")
    const [speakers, setSpeakers] = useState("")
    const [menit, setMenit] = useState("")
    const [type, setType] = useState("")
    const [tags, setTags] = useState("")
    const [image, setImage] = useState("")
    const [desciption, setDescription] = useState("")
    const [listSpeakers, setListSpeakers] = useState([])
    const toast = useToast()
    

    const getSpeakers = async () => {
        const querySnapshot = await getDocs(collection(db, "speakers"));
        let newArr = [];
        querySnapshot.forEach((doc) => {
          let newData = doc.data();
          newData.id = doc.id;
          newArr.push(newData);
        });
        setListSpeakers(newArr);
        console.log(newArr, 'ini data speaker')
      };  
    
    useEffect(() => {
        getSpeakers()
    
      return () => {
        setListSpeakers([])
      }
    }, [])
    

    const handleEdit = async () => {
        const addData = {
            title: title? (title) : (editData?.title),
            speakers : speakers? (speakers) : (editData?.speakers),
            menit : menit? (menit) : (editData?.menit),
            type: type? (type) : (editData?.type),
            tags: tags,
            image: image,
            description : desciption? (desciption) : (editData?.description),
        }

        try {
            if (addData.tags) {
                let text = addData.tags;
                const lowerText = text.toLowerCase();
                addData.tags = lowerText.split(",");
              }else{
                addData.tags = editData.tags
              }

            if(addData.image){
                const imageResult = await uploadFile(addData.title, "content", addData["image"]);
                addData.image = imageResult.image_original;
                addData.thumbnail = imageResult.image_thumbnail;
            }else{
                addData.image = editData?.image
            }

                await updateDoc(doc(db, "content", editData?.id), addData);
                toast({
                    title: 'Success',
                    description: 'Succes Edit Data',
                    position: 'top-right',
                    status: 'success',
                    duration: 3000,
                    isClosable: true
                })
            

        } catch (error) {
           console.log(error) 
        }
    }

  return (
    <SimpleGrid columns={[1, null, 2]}>
              <Center >
                <VStack w={"80%"}>
                    <Heading  color={colors.white}>Edit</Heading>
                <Image src={editData?.thumbnail}/>
                <Box  color={colors.white}  fontWeight="bold" fontSize="17">{editData?.title}</Box>
                <Box   color={colors.white} fontWeight="bold">{editData?.type}</Box>

                <Box  color={colors.white} >{editData?.menit}</Box>
                <Box>
                  <Text  color={colors.white} >{editData?.description}</Text>
                </Box>
                <Box>
                <HStack spacing={3} >
                  {editData?.tags.map((x, index) => (
                    <Tag key={index}  bgColor={colors.theme} color={colors.black}>{x}</Tag>
                  ))}
                </HStack>
                </Box>
                </VStack>
              </Center>
              <Center>
                <Box width="3xl">
                  <VStack align="start" spacing={3} >
                  <Text fontWeight="bold" color={colors.white}>Title</Text>
                  <Input  color={colors.white} m="1" type="text" placeholder={editData?.title} onChange={(e) => setTitle(e.target.value)} />

                  <Text fontWeight="bold" color={colors.white}>Speaker</Text>
                  <Select color={colors.white} m="1" placeholder="Speakers" id="speakers" onChange={(e) => setSpeakers(e.target.value)}>
                    {listSpeakers ? listSpeakers.map((x) => <option key={x.id}value={x.id}>{x.name}</option>) : <></>}
                </Select>

                <Text fontWeight="bold" color={colors.white}>Type</Text>
                <Select color={colors.white} m="1" placeholder="Type" id="type" onChange={(e) => setType(e.target.value)}>
                    <option value="series">Series</option>
                    <option value="full">Full</option>
                </Select>
                <Text fontWeight="bold" color={colors.white}>Durasi</Text>
                  <Input  color={colors.white}  m="1" type="text" placeholder={editData?.menit} onChange={(e) => setMenit(e.target.value)} />

                  <Text fontWeight="bold" color={colors.white}>Tag</Text>
                  <Input  color={colors.white}  m="1" type="text" placeholder={editData?.tags} onChange={(e) => setTags(e.target.value)} />
                  <Text fontSize="xs" color="red" fontWeight="bold">* Image (JPG 16:9)</Text>
                    <Input m="1" id="image" type="file" placeholder="Image URL" onChange={(e) => setImage(e.target.files[0])} />

                    <Text fontWeight="bold" color={colors.white}>Deskripsi</Text>
                  <Input  color={colors.white}  m="1" type="text" placeholder={editData?.description === undefined ? ("deskripsi") : (editData?.description)} onChange={(e) => setDescription(e.target.value)} />
                  </VStack>
                  <HStack>
                  <Button m="1" bgColor="green" onClick={() => handleEdit()}>
                    Update
                  </Button>
                  <Button m="1" bgcolor="red" onClick={() => setEditData(null)}>
                    Cancel
                  </Button>
                  </HStack>
                </Box>
              </Center>
            </SimpleGrid>
  )
}

export default EditDataContent